module.exports = "/images/es-cn.svg?19212ec171508bec9988f71117783212";